<template>
  <div class="robins-egg-bkgr pa-8">
    <div class="stockli-admin-container">
      <div class="h2">Set or Change Your Location</div>
      <div class="participant-details-box mb-9">
        <div class="bold-text lg-text">After you set your location, all pre-registered customers you claim will be assigned to you and to this selected location.</div>
      </div>
      
      <div class="h5">Find your Demo Event Location</div>
      <v-data-table
        :items="locations"
        :headers="headers"
        class="location-table"
        hide-default-footer
        :page.sync="page"
        :items-per-page="10"
        @page-count="pageCount = Math.min($event, 8)"
        disable-sort
        mobile-breakpoint="500"
        :loading="loading"
        @click:row="SelectRow"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-text-field ref="filterField" v-model="filter" append-icon="mdi-magnify" label="Search" block single-line hide-details />
          </v-toolbar>
        </template>
      </v-data-table>
      <div class="pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
      <v-dialog v-model="completeDialog" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Location set!</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="py-5">
              <div class="mb-2">Claimed customers will now be listed as attending:</div>
              <div class="h5">"{{ location }}"</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="FinishDialog">View participants</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";

export default {
  name: "ChangeLocation",
  components: {
  },
  data: () => ({
    locations: [],
    loading: false,
    headers: [
      { text: "Location", value: "Name" },
      { text: "State", value: "State" },
    ],
    filterTimeout: undefined,
    filter: "",

    page: 1,
    pageCount: 0,

    completeDialog: false,
  }),
  computed: {
    location() {
      if (this.$store.state.location) {
        return this.$store.state.location.Name;
      } else {
        return "No location set!";
      }
    },
  },
  mounted() {
    if (this.$refs.filterField) this.$refs.filterField.focus();
    this.RefreshData();
  },
  methods: {
    async RefreshData() {
      try {
        this.loading = true;
        this.locations = await API.GetLocations(this.filter);
      } finally {
        this.loading = false;
      }
    },
    SelectRow(row) {
      this.$store.commit("SetLocation", row);
      this.completeDialog = true;
    },
    FinishDialog() {
      this.completeDialog = false;
      this.$router.push("/participants");
    },
  },
  watch: {
    filter() {
      // delay / debounce until x ms have passed
      if (this.filterTimeout) clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.RefreshData();
      }, 500);
    },
  },
}
</script>
<style scoped lang="scss">
.location-table ::v-deep tbody tr :hover {
  cursor: pointer;
}
</style>
